import { ClickOutsideModule } from '../../../@dva/shared/click-outside/click-outside.module';
import { CommonModule } from '@angular/common';
import { CardModule } from '../../../@dva/shared/card/card.module';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../../@dva/shared/material-components.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScrollbarModule } from '../../../@dva/shared/scrollbar/scrollbar.module';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarProgressComponent } from './toolbar-progress/toolbar-progress.component';
import { ToolbarFullscreenToggleComponent } from './toolbar-fullscreen-toggle/toolbar-fullscreen-toggle.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { ToolbarSidenavMobileToggleComponent } from './toolbar-sidenav-mobile-toggle/toolbar-sidenav-mobile-toggle.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ScrollbarModule,
    FormsModule,
    ClickOutsideModule,
    CardModule,
    TranslateModule,
  ],
  declarations: [
    ToolbarComponent,
    ToolbarUserComponent,
    ToolbarNotificationsComponent,
    ToolbarFullscreenToggleComponent,
    ToolbarSidenavMobileToggleComponent,
    ToolbarProgressComponent,
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule {}
